// extracted by mini-css-extract-plugin
module.exports = {"border":"home_border__-qAPI","greenFont":"home_greenFont__IcRbo","jumbotron":"home_jumbotron__3KHA8","name":"home_name__R4EzW","desc":"home_desc__d6Yr0"};